import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.GlobalCommandView'

export default defineMessages({
  conversationTitle: {
    id: `${scope}.conversationTitle`,
    defaultMessage: 'New order request with Guided Intake',
  },
  newRequestLabel: {
    id: `${scope}.newRequestLabel`,
    defaultMessage: 'New request',
  },
})
